// src/index.ts
import { Connector } from "wagmi/connectors";
import {
  UserRejectedRequestError,
  custom,
  createWalletClient
} from "viem";
import { EthereumProvider } from "@joyid/ethereum-provider";
import { EthereumProvider as EthereumProvider2 } from "@joyid/ethereum-provider";
var JoyIdConnector = class extends Connector {
  constructor({ chains, options }) {
    super({ chains, options });
    this.id = "joyid";
    this.name = "JoyID";
    this.ready = true;
    this.provider = new EthereumProvider(chains, options);
  }
  async connect(options) {
    const account = this.provider.getAccount();
    let chainId = this.provider.getChainId();
    if (account) {
      if (options?.chainId) {
        this.provider.switchChain(chainId);
        chainId = options.chainId;
      }
      return {
        account,
        chain: {
          id: chainId,
          unsupported: false
        }
      };
    }
    try {
      this?.emit("message", { type: "connecting" });
      const address = await this.provider.connect();
      return {
        account: address,
        chain: {
          id: chainId,
          unsupported: false
        }
      };
    } catch (error) {
      if (error instanceof Error && error?.message.includes("User rejected")) {
        throw new UserRejectedRequestError(error);
      }
      throw error;
    }
  }
  async getWalletClient() {
    const chainId = this.provider.getChainId();
    const chain = this.chains.find((x) => x.id === chainId);
    const account = await this.getAccount();
    if (chain == null) {
      throw new Error(`Unsupported chain id: ${chainId}`);
    }
    if (account == null) {
      throw new Error(`No connected account`);
    }
    return createWalletClient({
      account,
      chain,
      transport: custom(this.provider)
    });
  }
  disconnect() {
    return new Promise((resolve) => {
      this.provider.disconnect();
      resolve();
    });
  }
  isAuthorized() {
    return Promise.resolve(this.provider.getAccount() !== null);
  }
  getAccount() {
    const address = this.provider.getAccount();
    if (address == null) {
      throw new Error("No connected account");
    }
    return Promise.resolve(address);
  }
  switchChain(chainId) {
    const chain = this.provider.switchChain(chainId);
    this.emit("change", { chain: { id: chainId, unsupported: false } });
    return Promise.resolve(chain);
  }
  getChainId() {
    return Promise.resolve(this.provider.getChainId());
  }
  getProvider(_config) {
    return Promise.resolve(this.provider);
  }
  onDisconnect() {
    this?.emit("disconnect");
  }
  onChainChanged(chainId) {
    this.emit("change", { chain: { id: chainId, unsupported: true } });
  }
  onAccountsChanged(_accounts) {
  }
};
export {
  EthereumProvider2 as EthereumProvider,
  JoyIdConnector
};
